import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useRouteError } from 'react-router-dom';
export function RemoteRouteErrorElement({ route }) {
    const error = useRouteError();
    if (error['response'] && error['response']['data']) {
        const errorDetails = error['response']['data'];
        errorDetails.route = route;
        throw new Error('Error in server response', { cause: errorDetails });
    }
    else {
        throw new Error(error.stack, { cause: route });
    }
    return _jsx(_Fragment, {});
}
